import React, { useEffect } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import DetailInfoComponentThumbnail from "../../../components/detailInfo/detailInfoComponentThumbnail";
import { SectionModel } from "../../../models/components.model";

function _GuarantorInfo(props: any) {
  const sections: SectionModel[] = [
    {
      dataKey: "amount",
      rowCol: 4,
      title: "مبلغ به عدد (ریال)",
      dataPostValue: "ریال",
      hasThousandSeparatorFormat: true,
    },
    { dataKey: "expectedHolder", rowCol: 4, title: "در وجه" },
    { dataKey: "bankName", rowCol: 4, title: " بانک" },
    { dataKey: "expectedIdCode", rowCol: 4, title: "شناسه ملی" },
    { dataKey: "dueDatePersian", rowCol: 4, title: "تاریخ سررسید" },
    {
      dataKey: "inquiryDueDatePersian",
      rowCol: 4,
      title: "تاریخ سررسیداستعلام شده",
    },
    {
      dataKey: "acceptDate_Persian",
      rowCol: 4,
      title: "تاریخ تایید دریافت چک",
    },
    { dataKey: "signer", rowCol: 4, title: "امضاء کننده" },
    { dataKey: "seriesNo", rowCol: 4, title: "شماره سری  چک" },
    { dataKey: "serialNo", rowCol: 4, title: "شماره سریال چک" },
    { dataKey: "sayadNumber", rowCol: 4, title: "شماره صیادی" },
    { dataKey: "fromIban", rowCol: 4, title: "شماره  شبا" },
    {
      dataKey: "branchCode",
      rowCol: 4,
      title: "کد شعبه صادر کننده",
      // dataPostValue: "----------",
    },
    { dataKey: "inquiryReasonTitle", rowCol: 6, title: "توضیحات" },
  ];

  return (
    <DetailInfoComponentThumbnail
      sections={sections}
      data={props.data}
      documentList={props?.documentList}
      height={"20vh"}
      showFooter={false}
      showDoc={props.withoutDoc}
      compareHistory={props.compareHistory}
    />
  );
}

export default function GuarantorInfo(props: any) {
  const [validateDate, setValidateDate] = React.useState(false);
  const [compareHistory, setCompareHistory] = React.useState(false);
  useEffect(() => {
    const inquiryDate = props.data?.inquiryDueDatePersian
      ? props.data?.inquiryDueDatePersian
      : null;
    const dueDate = props.data?.dueDatePersian
      ? props.data?.dueDatePersian
      : null;
    if (inquiryDate != undefined && inquiryDate != null) {
      setValidateDate(inquiryDate! < dueDate!);
    }
    props?.data?.dueDatePersian! != props?.data?.inquiryDueDatePersian! &&
    props?.data?.inquiryDueDatePersian!
      ? setCompareHistory(true)
      : setCompareHistory(false);
  }, []);

  let fileArray: any = [];
  fileArray.push(props?.data?.rearImage);
  fileArray.push(props?.data?.frontImage);
  const child = (
    <>
      {" "}
      <_GuarantorInfo
        data={props.data}
        withoutDoc={props.withoutDoc}
        documentList={fileArray}
        compareHistory={compareHistory}
      />
      {/* <DocumentInfoComponentSingle data={data?.file} /> */}
    </>
  );
  return (
    <DivisionCmp
      child={child}
      title={"اطلاعات چک ضمانت"}
      validateDate={validateDate}
      marginTop={"8px"}
    />
  );
}
